module.exports = __webpack_public_path__ + "img/sf-logo.c494aaf.png";